export const FETCHING_MYD_ACTIVITIES = 'FETCHING_MYD_ACTIVITIES'
export const FETCHED_MYD_ACTIVITIES = 'FETCHED_MYD_ACTIVITIES'
export const FETCHING_MYD_ACTIVITY = 'FETCHING_MYD_ACTIVITY'
export const FETCHED_MYD_ACTIVITY = 'FETCHED_MYD_ACTIVITY'


const mydActivitiesInit = {
  isFetching: false,
  data: [],
  meta: {
    maxPage: 0,
    page: 1,
    count: 0,
  },
}

export function mydActivities(mydActivities=mydActivitiesInit, action) {
  switch(action.type) {
    case FETCHING_MYD_ACTIVITIES:
      return {
        ...mydActivitiesInit,
        isFetching: true,
      }
    case FETCHED_MYD_ACTIVITIES:
      return {
        isFetching: false,
        data: action.mydActivities,
        meta: action.meta,
      }
    default:
      return mydActivities
  }
}


const mydActivityInit = {
  isFetching: false,
  data: {},
}

export function mydActivity(mydActivity=mydActivityInit, action) {
  switch(action.type) {
    case FETCHING_MYD_ACTIVITY:
      return {
        isFetching: true,
        data: {},
      }
    case FETCHED_MYD_ACTIVITY:
      return {
        isFetching: false,
        data: action.mydActivity,
      }
    default:
      return mydActivity
  }
}
